import { ReactComponent as OnePageFirstStyleIcon } from 'assets/icons/OnePageFirstStyleIcon.svg';
import { ReactComponent as OnePageSecondStyleIcon } from 'assets/icons/OnePageSecondStyleIcon.svg';
import { ReactComponent as OnePageThirdStyleIcon } from 'assets/icons/OnePageThirdStyleIcon.svg';

import { IOnePageStyles, ONE_PAGE_STYLE_OPTIONS } from '../types';

export const getOnePageCurrentStyleIcon = (onePageStyle: IOnePageStyles) => {
  const onePageIconsMap = new Map([
    [ONE_PAGE_STYLE_OPTIONS.FIRST_STYLE, <OnePageFirstStyleIcon />],
    [ONE_PAGE_STYLE_OPTIONS.SECOND_STYLE, <OnePageSecondStyleIcon />],
    [ONE_PAGE_STYLE_OPTIONS.THIRD_STYLE, <OnePageThirdStyleIcon />],
  ]);

  return onePageIconsMap.get(onePageStyle) ?? <></>;
};
